<template>
  <connectionTextAction v-if="content.actionType == 1 && content.styleType == 3" :content="content"></connectionTextAction>
  <div
    v-else
    class="action-container"
    :id="content.key"
    :class="[ 
      content.isBlock === 1 ? 'action-container-block' : '',
      content.isInBlock === 1 ? 'action-container-in-block' : '',
      device.isMobile ? 'action-container-mobile' : '',
      content.styleType === 2 ? 'action-container-en' : '',
    ]"
  >
    <p
      class="action-title"
      :id="`${content.key}-1`"
      v-if="content.showTitle !== 2"
      :style="{
        fontFamily: content.titleStyle.fontFamily || '',
        fontSize: (content.titleStyle.fontSize + 'rem') || '',
        lineHeight: (content.titleStyle.lineHeight + 'rem') || '',
        textIndent: (typeof content.titleStyle.textIndent === 'string') ? content.titleStyle.textIndent :
          (typeof content.titleStyle.textIndent === 'number') ? (content.titleStyle.textIndent + 'rem') : '',
        fontWeight: content.titleStyle.fontWeight || '',
        textDecoration: content.titleStyle.underline === 1 ? 'underline' : '',
        fontStyle: content.titleStyle.fontItalic === 1 ? 'italic' : '',
        textAlign: content.titleStyle.textAlign || '',
        color: content.titleStyle.color || '',
        backgroundColor: content.titleStyle.backgroundColor || '',
      }"
    ><span class="action-title-example" v-if="content.isExample">示例题</span>{{ content.title }} <span class="reset" v-if="Array.isArray(content.content)" @click.stop="reset"></span></p>
    <!-- <div class="reset" v-if="Array.isArray(content.content)" @click.stop="reset"></div> -->
    <template v-if="Array.isArray(content.content)">
      <template v-for="item in content.content">
        <template v-if="!item.actionType || item.actionType === 1">
          <connectionEnAction v-if="item.styleType === 2" :key="item.key" :id="item.key" :ref="item.key" :content="item" @updateAnswer="updateAnswer" :showReset="false"></connectionEnAction>
          <connectionAction v-else :key="item.key" :id="item.key" :ref="item.key" :content="item" @updateAnswer="updateAnswer" :showReset="false"></connectionAction>
        </template>
        <template v-if="!item.actionType || item.actionType === 2">
          <sortEnAction v-if="item.styleType === 2" :key="item.key" :id="item.key" :ref="item.key" :content="item" @updateAnswer="updateAnswer" :showReset="false"></sortEnAction>
          <sortAction v-else :key="item.key" :id="item.key" :ref="item.key" :content="item" @updateAnswer="updateAnswer" :showReset="false"></sortAction>
        </template>
        <scratchAction :key="item.key" :id="item.key" :ref="item.key" v-if="!item.actionType || item.actionType === 3" :content="item" :showReset="false"></scratchAction>
        <jigsawAction :key="item.key" :id="item.key" :ref="item.key" v-if="!item.actionType || item.actionType === 4" :content="item" @updateAnswer="updateAnswer" :showReset="false"></jigsawAction>
        <!-- <dynamicImage :key="item.key" :id="item.key" v-if="!item.actionType || item.actionType === 5" :content="item"></dynamicImage> -->
      </template>
    </template>
    <template v-else>
      <template v-if="!content.actionType || content.actionType === 1">
        <connectionEnAction v-if="content.styleType === 2" :id="`${content.key}-2`" :content="content.content" @updateAnswer="updateAnswer"></connectionEnAction>
        <connectionAction v-else :id="`${content.key}-2`" :content="content.content" @updateAnswer="updateAnswer"></connectionAction>
      </template>
      <template v-if="!content.actionType || content.actionType === 2">
        <sortEnAction v-if="content.styleType === 2" :id="`${content.key}-2`" :content="content.content" @updateAnswer="updateAnswer"></sortEnAction>
        <sortAction v-else :key="content.key" :id="`${content.key}-2`" :content="content.content" @updateAnswer="updateAnswer"></sortAction>
      </template>
      <scratchAction :id="`${content.key}-2`" v-if="!content.actionType || content.actionType === 3" :content="content.content"></scratchAction>
      <jigsawAction :id="`${content.key}-2`" v-if="!content.actionType || content.actionType === 4" :content="content.content" @updateAnswer="updateAnswer"></jigsawAction>
      <dynamicImage :id="`${content.key}-2`" v-if="!content.actionType || content.actionType === 5" :content="content"></dynamicImage>
    </template>
    
  </div>
</template>
<script>
/*
交互组件
*/
import connectionAction from "./template/connection.vue";
import connectionEnAction from "./template/connectionEn.vue";
import connectionTextAction from "./template/connectionText.vue";
import sortAction from "./template/sort.vue";
import sortEnAction from "./template/sortEn.vue";
import scratchAction from "./template/scratch.vue";
import jigsawAction from "./template/jigsaw.vue";
import dynamicImage from "./template/dynamicImage.vue";
import { getActionData, setActionData } from "@/utils/storage";

export default {
  name: "actionIndex",
  components: {
    connectionAction,
    connectionEnAction,
    connectionTextAction,
    sortAction,
    sortEnAction,
    scratchAction,
    jigsawAction,
    dynamicImage,
  },
  props: {
    content: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  methods: {
    updateAnswer(newAnswer) {
      this.$emit('updateAnswer', newAnswer)
    },
    reset() {
      if(Array.isArray(this.content.content)) {
        
        let historyData = (JSON.parse(getActionData()) || {})
        this.content.content.forEach(item => {
          const childRef = this.$refs[item.key];
          if (childRef && childRef[0]) {
            childRef[0].reset(false);
            delete historyData[item.key]
          }
        })
        setActionData(JSON.stringify(historyData));
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.action-container{
  padding: 15rem 0;
  position: relative;

  .action-title{
    display: block;
    margin: 10rem 0;
    width: 100%;
    font-size: 18rem;
    line-height: 28rem;
    color: #1A1A1A;
    text-indent: 0;

    .action-title-example{
      display: inline-block;
      font-size: 18rem;
      color: #23B08A;
      line-height: 32rem;
      background: #DFF6EF;
      border-radius: 4rem;
      padding: 0 8rem;
      margin-right: 10rem;
    }
  }
  
  .reset{
    width: 34rem;
    height: 34rem;
    background: url(~@/assets/images/books/bookExample/reset.png) center center no-repeat;
    background-size: contain;
    // position: absolute;
    // top: 53rem;
    // right: 40rem;
    cursor: pointer;
    float:right;
  }
}

.action-container.action-container-block{
  background: rgba(255,255,255,0.7);
  box-shadow: 0rem 3rem 16rem 0rem rgba(32,37,36,0.1);
  border-radius: 10rem;
  padding: 20rem 30rem;
  position: relative;

  .action-title{
    display: block;
    margin-top: 10rem;
    width: 100%;
    text-align: center;
    font-size: 20rem;
    line-height: 32rem;
    color: #1A1A1A;
    font-weight: bold;
  }
}

.action-container-in-block{
  background: #fff;
  padding: 20rem 0;

  .action-title{
    display: block;
    width: 100%;
    font-size: 20rem;
    line-height: 44rem;
    color: #333;
    font-weight: bold;
    text-indent: 2em;
    padding: 0 20rem;
  }
  
  .reset{
    top: 75rem;
    right: 40rem;
    cursor: pointer;
  }
}

.action-container-mobile.action-container-in-block{
  .action-title{
    font-size: 26rem;
    line-height: 44rem;
  }
}
.action-container.action-container-mobile{
  .action-title{
    font-size: 28rem;
    line-height: 44rem;
  }
  .reset{
    width: 44rem;
    height: 44rem;
  }
  .action-title-example{
    font-size: 24rem;
    line-height: 44rem;
    padding: 0 14rem;
    margin-right: 20rem;
  }
}
.action-container.action-container-block.action-container-mobile{
  padding: 34rem 30rem;
}
.action-container-en{
  width: 100% !important;
  margin: 0 !important;
}
</style>